// Libraries
import { useEffect } from "react";
import GoogleAnalytics from "react-ga4";

// Components.
import Hero from "../components/pages/home/Hero/Hero";
import Services from "../components/pages/home/Services/Services";
import Partners from "../components/pages/home/partners/Partners";
import About from "../components/pages/home/about/About";
import HomeFeatures from "../components/pages/home/features/HomeFeatures";
import Tools from "../components/pages/home/tools/Tools";
import Contact from "../components/pages/home/contact/Contact";
import EquitrackForIndustry from "../components/pages/industries/EquitrackForIndustry"

export default function Home() {
    useEffect(() => {
        GoogleAnalytics.send({ hitType: "pageview", page: window.location.pathname, title: "Home" });

    const scrollToHash = () => {
     const hashLink = window.location.hash;
     if (hashLink) {
       const elementId = hashLink.substring(1);
       const targetElement = document.getElementById(elementId);
       if (targetElement) {
         setTimeout(() => {
           targetElement.scrollIntoView({ behavior: 'smooth' });
         }, 100);
       }
     }
   };
   scrollToHash();
    }, []);

    return (
        <main>
            <Hero />
            <EquitrackForIndustry/>
            <Services />
            <Partners />
            <About />
            <HomeFeatures />
            <Tools />
            <Contact />
        </main>
    )
}
